import { useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { Mail, LogIn } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const StudentLogin = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleMagicLink = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/magic-link`, { email });
      toast.success('Magic link sent! Check your email.');
      setEmail('');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to send magic link');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 dark:from-slate-900 dark:via-purple-900 dark:to-slate-900 flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex w-16 h-16 bg-gradient-to-br from-indigo-500 to-purple-400 rounded-2xl items-center justify-center shadow-lg mb-4">
            <LogIn className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-4xl font-bold text-slate-800 dark:text-slate-100 mb-2" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Student Portal
          </h1>
          <p className="text-slate-600 dark:text-slate-400">Access your certification vouchers</p>
        </div>

        <Card className="border-slate-200 dark:border-slate-700 shadow-xl">
          <CardHeader>
            <CardTitle>Student Access</CardTitle>
            <CardDescription>Enter your email to receive a secure login link</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleMagicLink} className="space-y-4">
              <div>
                <Label htmlFor="email">Student Email</Label>
                <Input
                  id="email"
                  type="email"
                  data-testid="magic-email-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="student@example.com"
                />
                <p className="text-sm text-slate-500 dark:text-slate-400 mt-2">
                  We'll send you a magic link to access your vouchers securely
                </p>
              </div>
              <Button 
                type="submit" 
                className="w-full bg-gradient-to-r from-indigo-500 to-purple-400 text-white hover:from-indigo-600 hover:to-purple-500"
                disabled={loading}
                data-testid="magic-link-submit-button"
              >
                <Mail className="w-4 h-4 mr-2" />
                {loading ? 'Sending...' : 'Send Magic Link'}
              </Button>
            </form>
          </CardContent>
        </Card>
        
        <p className="text-center text-sm text-slate-600 dark:text-slate-400 mt-4">
          Check your email inbox and spam folder for the login link
        </p>
      </div>
    </div>
  );
};

export default StudentLogin;